import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import classNames from 'classnames';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { Separator } from 'wix-rich-content-ui-components';
import '../buttons/index.js';
import { t as toolbarStyles, T as ToolbarContent } from '../../ToolbarContent-98b42551.js';
import { getRelativePositionStyle, getToolbarPosition, setVariables } from './toolbarUtils.js';
import { BUTTONS } from '../buttons/keys.js';
import '../buttons/createBlockButton.js';
import '../buttons/createBlockAlignmentButton.js';
import '../buttons/createBlockAlignmentAndSizeButton.js';
import '../buttons/createBlockSizeButton.js';
import '../buttons/createSliderPanelButton.js';
import '../baseToolbarButton.js';
import 'react-dom';
import 'wix-rich-content-common';
import '../buttons/BlockLinkButton.js';
import '../buttons/BlockSpoilerButton.js';
import '../../Icons/SpoilerButtonIcon.js';
import '../../Icons/SizeSmallIcon.js';
import '../../Icons/SizeMediumIcon.js';
import '../../Icons/SizeLargeIcon.js';
import '../../Icons/SizeOriginalIcon.js';
import '../../Icons/AlignCenterIcon.js';
import '../../Icons/SizeSmallCenterIcon.js';
import '../../Icons/SizeSmallLeftIcon.js';
import '../../Icons/SizeSmallRightIcon.js';
import '../../Icons/SizeBestFitIcon.js';
import '../../Icons/SizeFullWidthIcon.js';
import '../../Icons/TrashIcon.js';
import '../../Icons/WidthIcon.js';
import '../../Icons/HeightIcon.js';
import 'react-measure';
import '../../style-inject.es-746bb8ed.js';
import '../../consts.js';
import '../default-toolbar-settings.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function createInlinePluginToolbar({
  buttons,
  theme,
  commonPubsub,
  isMobile,
  t,
  name,
  getToolbarSettings
}) {
  var _a;
  return _a = class extends Component {
    constructor(props) {
      super(props);
      __publicField(this, "isToolbarOnFocus", () => {
        var _a2;
        return (_a2 = this.ref) == null ? void 0 : _a2.contains(document.activeElement);
      });
      __publicField(this, "cursorIsOnInlinePlugin", debounce(() => {
        const toolbarOnFocus = this.isToolbarOnFocus();
        const { boundingRect, type } = commonPubsub.get("cursorOnInlinePlugin") || {};
        if (toolbarOnFocus) {
          return;
        }
        this.hideToolbar();
        if (boundingRect && name.toUpperCase() === type) {
          this.pluginBoundingRect = boundingRect;
          this.showToolbar();
        }
      }, 40));
      __publicField(this, "onOverrideContent", (overrideContent) => {
        this.setState({ overrideContent });
      });
      __publicField(this, "hideToolbar", () => {
        this.setState({
          position: { transform: "scale(0)" },
          overrideContent: void 0,
          tabIndex: -1,
          isVisible: false
        });
      });
      __publicField(this, "getRelativePositionStyle", (boundingRect) => {
        const { position, updatedOffsetHeight } = getRelativePositionStyle({
          boundingRect,
          offset: this.offset,
          offsetHeight: this.offsetHeight,
          toolbarNode: this.ref,
          isMobile
        });
        this.offsetHeight = updatedOffsetHeight;
        return position;
      });
      __publicField(this, "showToolbar", () => {
        if (this.visibilityFn()) {
          if (this.state.isVisible) {
            this.setToolbarPosition();
          } else {
            this.setState({ isVisible: true });
          }
        }
      });
      __publicField(this, "setRef", (ref) => {
        this.ref = ref;
        if (ref) {
          this.setToolbarPosition();
        }
      });
      __publicField(this, "setToolbarPosition", () => {
        const position = getToolbarPosition({
          boundingRect: this.pluginBoundingRect,
          displayOptions: this.displayOptions,
          getRelativePositionStyle: this.getRelativePositionStyle,
          offset: this.offset
        });
        this.setState({ tabIndex: 0, position }, this.forceUpdate);
      });
      /*eslint-disable complexity*/
      __publicField(this, "PluginToolbarButton", ({ button, index, themedStyle, separatorClassNames }) => {
        if (button.component) {
          const Button = button.component;
          return /* @__PURE__ */ React.createElement(
            Button,
            {
              t,
              theme: themedStyle,
              toolbarOffsetTop: this.state.position && this.state.position["--offset-top"],
              toolbarOffsetLeft: this.state.position && this.state.position["--offset-left"]
            }
          );
        }
        switch (button.type) {
          case BUTTONS.SEPARATOR:
            return /* @__PURE__ */ React.createElement(Separator, { className: separatorClassNames, key: index });
          default:
            return null;
        }
      });
      __publicField(this, "onKeyDown", (e) => {
        if (e.keyCode === KEYS_CHARCODE.ESCAPE) {
          this.props.removeToolbarFocus && this.props.removeToolbarFocus();
        }
      });
      const { structure, offset, shouldCreate, visibilityFn, displayOptions, ToolbarDecoration } = setVariables({ buttons, getToolbarSettings, isMobile });
      this.structure = structure;
      this.offset = offset;
      this.shouldCreate = shouldCreate;
      this.visibilityFn = visibilityFn;
      this.displayOptions = displayOptions;
      this.ToolbarDecoration = ToolbarDecoration;
      this.state = {
        position: { transform: "scale(0)" },
        overrideContent: void 0,
        tabIndex: -1
      };
    }
    componentDidMount() {
      var _a2;
      commonPubsub.subscribe("cursorOnInlinePlugin", this.cursorIsOnInlinePlugin);
      if ((window == null ? void 0 : window.ResizeObserver) && this.ref) {
        this.resizeObserver = new ResizeObserver(debounce(this.cursorIsOnInlinePlugin, 40));
        (_a2 = this.resizeObserver) == null ? void 0 : _a2.observe(this.ref);
      }
    }
    componentWillUnmount() {
      var _a2;
      commonPubsub.unsubscribe("cursorOnInlinePlugin", this.cursorIsOnInlinePlugin);
      (_a2 = this.resizeObserver) == null ? void 0 : _a2.unobserve(this.ref);
    }
    shouldComponentUpdate(_nextProps, nextState) {
      return !!this.state.isVisible || !!nextState.isVisible;
    }
    scrollToolbar(event, leftDirection) {
      event.preventDefault();
      const { clientWidth, scrollWidth } = this.scrollContainer;
      this.scrollContainer.scrollLeft = leftDirection ? 0 : Math.min(this.scrollContainer.scrollLeft + clientWidth, scrollWidth);
    }
    render() {
      const { overrideContent, tabIndex, isVisible } = this.state;
      const { hide } = this.props;
      const toolbarContentProps = {
        overrideContent,
        tabIndex,
        theme,
        PluginToolbarButton: this.PluginToolbarButton,
        structure: this.structure
      };
      if (!this.shouldCreate) {
        return null;
      }
      const { toolbarStyles: toolbarTheme } = theme || {};
      if (this.visibilityFn() && isVisible) {
        const props = {
          style: __spreadProps(__spreadValues({}, this.state.position), {
            visibility: hide ? "hidden" : "visible",
            left: "var(--offset-left)",
            right: "unset"
          }),
          className: classNames(
            toolbarStyles.pluginToolbar,
            toolbarTheme && toolbarTheme.pluginToolbar
          ),
          "data-hook": name ? `${name}PluginToolbar` : null,
          ref: this.setRef,
          onKeyDown: this.onKeyDown,
          tabIndex: "0"
        };
        const ToolbarWrapper = this.ToolbarDecoration || "div";
        return /* @__PURE__ */ React.createElement(ToolbarWrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(ToolbarContent, __spreadValues({}, toolbarContentProps)));
      } else {
        return null;
      }
    }
  }, __publicField(_a, "propTypes", {
    hide: PropTypes.bool,
    removeToolbarFocus: PropTypes.func
  }), _a;
}

export { createInlinePluginToolbar as default };
//# sourceMappingURL=createInlinePluginToolbar.js.map
